import {
  basePath
 } from '../common/path'
 
 const path = {
  getDiagnostics: basePath.concat('/diagnostic-log'),
  getGroupDiagnostics: basePath.concat('/absenteeism/groups-diagnostics'),
  getDiagnosticsById: basePath.concat('/absenteeism/diagnostics'),
  getInfoSelect: basePath.concat('/info-selects'),
  getCalifications: basePath.concat('/qualification-detail'),
  saveDiagnostic: basePath.concat('/diagnostic-log'),
  detailDiagnostic: basePath.concat('/diagnostic-log'),
  editDiagnostic: basePath.concat('/diagnostic-log'),
  saveQualification: basePath.concat('/qualification-detail'),
  detailQualification: basePath.concat('/qualification-detail'),
  editQualification: basePath.concat('/qualification-detail'),
  getPCLs: basePath.concat('/pcl'),
  savePCL: basePath.concat('/pcl'),
  editPCL: basePath.concat('/pcl'),
  detailPCL: basePath.concat('/pcl'),
  statistics: basePath.concat('/diagnostic-log/statistics'),
  locations: '/locations/analyst',
  areas: '/areas/analyst',
  employees: basePath.concat('/employee/by-location'),
 }
 export { path }